import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { logoutUser } from 'app/action-creators';
import { metaActions } from 'app/actions';

import Header from './header';

class Layout extends React.Component {
  constructor() {
    super();
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    const { versionInfo, setAppVersionThunk } = this.props;
    if (!versionInfo) {
      setAppVersionThunk();
    }
  }

  logout() {
    this.props.logoutUser();
    this.props.history.push('/login');
  }

  render() {
    const { versionInfo } = this.props;
    const appVersion = versionInfo
      ? `App Version: ${versionInfo.version} (build ${versionInfo.build_number}). Commit: ${versionInfo.commit.slice(0, 8)}`
      : '';

    return (
      <div className="container container--layout">
        <Header user={this.props.user} logout={this.logout} />
        <main>{this.props.children}</main>
        <footer>
          <div className="d-flex flex-column text-center small">
            {!!appVersion && <span>{appVersion}</span>}
            <span>© {new Date().getFullYear()} PHOENIX CONTACT</span>
          </div>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  versionInfo: state.meta.versionInfo,
});

export default withRouter(
  connect(mapStateToProps, { logoutUser, ...metaActions })(Layout)
);
